const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Loads the site-wide discount celebration (assets/ej-discount-celebration.js).
 *
 * Everything above this comment is Dawn's original constants.js, unchanged.
 * This hook lives here because theme.liquid already loads constants.js on every
 * page, and rewriting the 42KB layout on a live store to add one script tag was
 * the greater risk. The URL is derived from this file's own src so it keeps the
 * theme's CDN path and version, rather than being hardcoded.
 *
 * CACHE COUPLING — measured, not theoretical: the CDN caches by FULL URL
 * including ?v=, and the derived URL carries THIS file's version. So after any
 * edit to ej-discount-celebration.js, this file must be re-pushed too (any
 * whitespace change suffices) or the CDN keeps serving the old celebration
 * under the old version key. That is exactly what happened on the first
 * deploy: the fixed file was live at its bare URL while every page kept
 * loading the stale cached one. rev bumps below force it.
 * rev 4 (suppression CSS moved here to kill the flash)
 * rev 5 (2026-09-09: window.EJ_DISCOUNTS, the single shared code map)
 * rev 6 (2026-09-11: HUGE$SALE added - $50 off thrust-sync)
 * rev 7 (2026-09-12: celebration card inverted - forces the CDN to fetch
 *        the new ej-discount-celebration.js under this file's new ?v=)
 * rev 8 (2026-09-14: pulse added to BESTBUY15 + THANKYOU30, pebble to BESTBUY10 -
 *        mirrors the admin 'Applies to' lists; the Pulse/Pebble PDPs showed no
 *        discount card because they were missing here)
 * rev 9 (2026-09-14: pebble + muse added to THANKYOU30 - the Best Female Toys
 *        survey code; admin 'Applies to' already had them, so only Pulse
 *        struck its price on /collections/female-toys)
 * rev 10 (2026-09-23: no discount card on the policy and legal pages)
 * rev 11 (2026-09-23: the card shows once per code per browser, not per visit)
 */
/* THE DISCOUNT CODES, in one place.
 *
 * Read by assets/ej-discount-celebration.js (the "Your 15% discount is locked
 * in" sentence) and by snippets/pdp-buyflow.liquid (the discounted price card
 * on a product page). It used to live only in the celebration script; the buy
 * flow needed the same figures, and two copies of a price table are how a
 * page ends up promising one discount and pricing another. Defined here
 * because this file is what loads the celebration script - it always exists
 * before that runs - and it has executed before DOMContentLoaded, which is when
 * the buy flow first reads it.
 *
 * Each entry, taken from the discount's own definition in the admin
 * (Discounts > code > "Applies to"), 2026-09-09:
 *   pct       percentage off, as a whole number
 *   amt       OR a fixed amount off, in CENTS (USD)
 *   products  the handles the code applies to. Omit it for a code that
 *             applies to every product. An EMPTY list means the code is
 *             scoped in a way the storefront cannot check (a collection), so
 *             the card is never discounted for it - the customer still gets
 *             the discount at checkout; the card simply does not guess.
 *
 * The buy flow only discounts the card when the code is here AND lists the
 * product it is on. A code that is not listed still gets the vaguer
 * celebration sentence and an undiscounted card - never a wrong number.
 * When a discount is edited in the admin, edit it here too.
 */
window.EJ_DISCOUNTS = {
  BESTBUY15: { pct: 15, products: ['thrust-sync', 'vacumate-automatic', 'pulse'] },
  BESTBUY10: { pct: 10, products: ['pro', 'vacumate-manual', 'pebble'] },
  WELCOME15: { pct: 15, products: ['pro', '3-in-1', 'synflex', 'glide', 'fresh', 'renewal-powder', 'make-it-feel-oh-so-real-with-our-lube-specially-formulated-for-the-erojoy-pro-118ml-4oz', 'keep-your-erojoy-fresh-clean-and-odorless-with-our-special-toy-safe-cleaner-118ml-4oz', 'xl-pro-sleeve', 'anal-bliss-pro-sleeve', 'minx-pro-sleeve', 'innocent-pro-sleeve', 'thrust', 'rumble', 'erojoy-rumble', 'erojoy-3-in-1', 'erojoy-fresh', 'erojoy-glide', 'erojoy-renewal-powder', 'thrust-minx-sleeve', 'thrust-xl-sleeve', 'thrust-original-sleeve', 'original-pro-sleeve', 'ring', 'pro-sleeve-bundle', 'x3', 'thrust-sync', 'fap-xxx', 'fap-rush', 'fap-intense', 'fap-edge', 'fap-anal-joy', 'fap-collection'] },
  BRENAN15: { pct: 15 },
  RENAMALIK: { pct: 15, products: ['pro', '3-in-1', 'synflex', 'glide', 'fresh', 'renewal-powder', 'xl-pro-sleeve', 'anal-bliss-pro-sleeve', 'minx-pro-sleeve', 'innocent-pro-sleeve', 'thrust', 'rumble', 'erojoy-rumble', 'erojoy-3-in-1', 'erojoy-fresh', 'erojoy-glide', 'erojoy-renewal-powder', 'thrust-minx-sleeve', 'thrust-xl-sleeve', 'thrust-sync'] },
  TOPSELLER15: { pct: 15, products: ['pro', 'x3', 'thrust-sync'] },
  MASTURBATE: { pct: 15, products: ['rumble', 'erojoy-rumble', 'thrust-sync'] },
  YOUROCK: { pct: 15, products: ['pro', '3-in-1', 'synflex', 'renewal-powder', 'xl-pro-sleeve', 'anal-bliss-pro-sleeve', 'minx-pro-sleeve', 'thrust', 'rumble', 'erojoy-3-in-1', 'erojoy-fresh', 'erojoy-renewal-powder', 'thrust-minx-sleeve', 'thrust-xl-sleeve', 'thrust-original-sleeve', 'original-pro-sleeve', 'x3', 'thrust-sync', 'fap-xxx', 'fap-rush', 'fap-intense', 'fap-edge', 'fap-anal-joy'] },
  FAPTAP: { pct: 15, products: ['pro', 'thrust'] },
  THANKYOU30: { pct: 30, products: ['thrust-sync', 'vacumate-automatic', 'vacumate-manual', 'pulse', 'pebble', 'muse'] },
  MUSETRIAL: { pct: 100, products: ['muse'] },
  FREEMUSE: { pct: 100, products: ['muse'] },
  VIBE20: { pct: 20, products: ['pulse', 'pebble', 'muse'] },
  THANKYOU30OFF: { pct: 30, products: ['x3'] },
  THANKSGERALD: { pct: 25, products: ['thrust-sync'] },
  ULTRACLIMAX: { pct: 20, products: ['x3'] },
  ANONYMOUS: { pct: 20, products: ['pro', '3-in-1', 'synflex', 'glide', 'fresh', 'renewal-powder', 'xl-pro-sleeve', 'anal-bliss-pro-sleeve', 'minx-pro-sleeve', 'innocent-pro-sleeve', 'thrust', 'rumble', 'erojoy-rumble', 'erojoy-3-in-1', 'erojoy-fresh', 'erojoy-glide', 'erojoy-renewal-powder', 'thrust-minx-sleeve', 'thrust-xl-sleeve', 'thrust-original-sleeve', 'original-pro-sleeve', 'ring', 'thrust-sleeve-bundle', 'x3', 'thrust-sync', 'fap-xxx', 'fap-rush', 'fap-intense', 'fap-edge', 'fap-collection'] },
  HIMEROS: { pct: 20, products: ['pro', '3-in-1', 'synflex', 'glide', 'fresh', 'renewal-powder', 'xl-pro-sleeve', 'anal-bliss-pro-sleeve', 'minx-pro-sleeve', 'innocent-pro-sleeve', 'thrust', 'rumble', 'erojoy-rumble', 'erojoy-3-in-1', 'erojoy-fresh', 'erojoy-glide', 'erojoy-renewal-powder', 'thrust-minx-sleeve', 'thrust-xl-sleeve', 'thrust-original-sleeve', 'original-pro-sleeve', 'x3', 'thrust-sync', 'fap-xxx', 'fap-rush', 'fap-intense', 'fap-edge', 'fap-anal-joy', 'thrust-xl-sleeve-upsell'] },
  YESPLEASE: { pct: 10 },
  CLICK10: { pct: 10, products: ['pro'] },
  /* Scoped to the "bestsellers" collection, not to products - see above. */
  '10OFF': { pct: 10, products: [] },
  /* $ in the code, so it arrives URL-encoded - see the canonical() note in
     snippets/coupon-auto-apply.liquid. The map is keyed on the DECODED
     code, which is what both readers look up. */
  'HUGE$SALE': { amt: 5000, products: ['thrust-sync'] },
  XVIDEOS: { amt: 5000, products: ['thrust-sync'] },
  RULE34: { amt: 5000, products: ['thrust-sync'] },
  FEEDBACK20: { amt: 2000, products: ['pro'] },
  BLUECHECK: { amt: 2000, products: ['pro'] }
};
/* Kill the two legacy discount notifications BEFORE they can mount.
 *
 * This used to live only in ej-discount-celebration.js, and Rudi still saw the
 * green pill flash briefly: that file arrives via a second network hop (this
 * script fetches it), while erojoy-main-popup.js — which builds the green
 * .disc-toast — is loaded directly by theme.liquid. Both are defer, and defer
 * scripts run in document order: constants.js is line ~112, the popup script
 * line ~925. So CSS injected HERE, synchronously, exists before that script
 * executes, and the toast is born hidden. No race, no flash.
 */
(function () {
  var s = document.createElement('style');
  s.id = 'ej-legacy-toast-kill';
  s.textContent = '.disc-toast{display:none!important}.ej-coupon-toast{display:none!important}';
  (document.head || document.documentElement).appendChild(s);
})();

(function () {
  var self = document.currentScript || document.querySelector('script[src*="constants.js"]');
  if (!self || !self.src) return;
  var url = self.src.replace(/constants\.js/, 'ej-discount-celebration.js');
  if (document.querySelector('script[src^="' + url.split('?')[0] + '"]')) return;
  var s = document.createElement('script');
  s.src = url;
  s.defer = true;
  (document.head || document.documentElement).appendChild(s);
})();
